import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

type PrompterType = 'SUCCESS' | 'ERROR' | 'WARNING';
type PrompterButtonTypes = 'BASIC' | 'PRIMARY' | 'WARN';

interface PrompterButton {
  text: string;
  type: PrompterButtonTypes;
  value: any,
  closeModal: boolean,
}

interface PrompterConfig {
  type: PrompterType
  text: string;
  title: string;
  buttons: Array<PrompterButton> | boolean;
}

const defaultButtons: Array<PrompterButton> = [
  {
    text: 'Ok',
    type: 'PRIMARY',
    value: true,
    closeModal: true,
  },
  {
    text: 'Cancel',
    type: 'BASIC',
    value: false,
    closeModal: true,
  },

];

@Component({
  selector: 'nw-prompter',
  templateUrl: './prompter.component.html',
  styleUrls: ['./prompter.component.scss']
})
export class NewellPrompterComponent implements OnInit {

  public type: PrompterType;
  public title: string;
  public text: string;

  public buttons: Array<PrompterButton>;


  constructor(
    public dialogRef: MatDialogRef<NewellPrompterComponent>,
    @Inject(MAT_DIALOG_DATA) public config: PrompterConfig) {

    this.type = config.type;
    this.title = config.title;
    this.text = config.text;

    if (Array.isArray(config.buttons)) {
      this.buttons = config.buttons;
    } else if (config.buttons === undefined || config.buttons === true) {
      this.buttons = Object.assign(defaultButtons);
    } else {
      this.buttons = [];
    }

  }

  ngOnInit(): void {}

  buttonClick(value: any) {
    this.dialogRef.close(value);
  }

}
